/**
 * TokenHoldersUserEvents
 * Registry of events for TokenHolders components
 */
export enum TokenHoldersUserEvents {
    ChangeTab = "Token Holders - Table - Change Tab",
    ClickLogincCta = "Token Holders - Login CTA",
}
